import { FederationClient } from "../../client";

import { SEND_ACCOUNT_RECOVERY, SEND_PASSWORD_RECOVERY } from "./recovery.mutations";

import type {
  ISendAccountRecoveryResponse,
  ISendAccountRecoveryVariables,
  ISendPasswordRecoveryResponse,
  ISendPasswordRecoveryVariables,
} from "./recovery.types";

export async function sendAccountRecovery(variables: ISendAccountRecoveryVariables) {
  const client = FederationClient({ cache: "no-store" });

  const response = await client.request<ISendAccountRecoveryResponse, ISendAccountRecoveryVariables>({
    document: SEND_ACCOUNT_RECOVERY,
    variables,
  });

  return response.sendAccountRecovery;
}

export async function sendPasswordRecovery(variables: ISendPasswordRecoveryVariables) {
  const client = FederationClient({ cache: "no-store" });

  const response = await client.request<ISendPasswordRecoveryResponse, ISendPasswordRecoveryVariables>({
    document: SEND_PASSWORD_RECOVERY,
    variables,
  });

  return response;
}
